export default __webpack_public_path__ + "static/media/cristian-bajenaru.1566d1ca.png";